var _polygon, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  fill: "#6FD87C"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "0,-3.590352 3.109336,1.795176 -3.109336,1.795176 0,-3.590352",
  transform: "matrix(2.592013 0 0 1.463193 12 7.387689)",
  strokeWidth: 0,
  fill: "#6FD87C"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2.4,
  height: 2.4,
  rx: 0,
  ry: 0,
  transform: "matrix(3.192958 0 0 4.470456 8.16845 10.014378)",
  strokeWidth: 0,
  fill: "#6FD87C"
})));
export default __webpack_public_path__ + "teg/media/UpIcon.397f031b.svg";
export { SvgComponent as ReactComponent };